import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LayoutModule } from '@angular/cdk/layout';
import { LoginComponent } from './login/login.component';
import { BaseComponent } from './base/base.component';
import { HeaderComponent } from './base/header/header.component';
import { FooterComponent } from './base/footer/footer.component';
import { MenuComponent } from './base/header/menu/menu.component';
import { HomeComponent } from './base/content/home/home.component';
import { NotificationComponent } from './base/content/notification/notification.component';
import { FaqComponent } from './base/content/faq/faq.component';
import { editComponent } from './base/content/edit/edit.component';
import { ModalsComponent } from './base/content/modals/modals.component';
import { ContentComponent } from './base/content/content.component';
import { AdministrationComponent } from './base/content/administration/administration.component';
import { ModalDownloadPdfComponent } from './base/content/modal-download-pdf/modal-download-pdf.component';
import { ModalDownloadWordComponent } from './base/content/modal-download-word/modal-download-word.component';
import { ModalPreviousEditionsComponent } from './base/content/modal-previous-editions/modal-previous-editions.component';
import { ModalTranscriptionComponent } from './base/content/modal-transcription/modal-transcription.component';
import { ModalMeetingComponent } from './base/content/modal-meeting/modal-meeting.component';
import { MatListModule } from '@angular/material/list';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranscriptionModuleComponent } from './base/content/transcription-module/transcription-module.component';
import { ModalNotificationComponent } from './base/content/modal-notification/modal-notification.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalEditionsMeetingComponent } from './base/content/modal-editions-meeting/modal-editions-meeting.component';
import { CoreModule } from './core/core.module';
import { ModalWarningComponent } from './base/content/modal-warning/modal-warning.component';
import { MsalInterceptor } from './core/msal/msal.interceptor';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { AccessControlService } from './core/services/accessControl.service';
import { AudioPlayerPortalComponent } from './core/portals/audio-player-portal/audio-player-portal.component';
import { AudioPlayerComponent } from './core/portals/audio-player-portal/audio-player/audio-player.component';

import { PortalModule } from '@angular/cdk/portal';
import { UserService } from './core/services/user.service';
import { AccessComponent } from './base/content/access-notification/access.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    BaseComponent,
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    HomeComponent,
    AccessComponent,
    NotificationComponent,
    FaqComponent,
    editComponent,
    ModalsComponent,
    ContentComponent,
    AdministrationComponent,
    ModalDownloadPdfComponent,
    ModalDownloadWordComponent,
    ModalPreviousEditionsComponent,
    ModalTranscriptionComponent,
    ModalMeetingComponent,
    TranscriptionModuleComponent,
    ModalNotificationComponent,
    ModalEditionsMeetingComponent,
    ModalWarningComponent,
    AudioPlayerPortalComponent,
    AudioPlayerComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatGridListModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    LayoutModule,
    MatListModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatProgressBarModule,
    NgxAudioPlayerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    PortalModule
  ],
  providers: [
    DatePipe,
    MsalInterceptor,
    {
      provide: APP_INITIALIZER,
      useFactory: (accessControlService: AccessControlService) => () => {
        accessControlService.checkItHasRoles();
      },
      deps: [AccessControlService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
